export default {
  generic: {
    loading: "Loading...",
    confirm: {
      areYouSure: "Are you sure?",
      areYouSureDelete: "Are you sure you want to delete this?",
      yesDelete: "Yes, delete it",
      cancel: "Cancel",
      close: "Close",
      okay: "Okay",
      confirm: "Confirm",
    },
    messages: {
      usdValuationsEstimate: "USD valuations displayed are estimates",
    },
    tbc: "TBC",
  },
  form: {
    labels: {
      account: "Account",
      accountFrom: "From Account",
      accountTo: "To Account",
      advancedSearch: "Advanced Search",
      amount: "Amount",
      asset: "Asset",
      lmaxEntity: "LMAX Entity",
      entity: "Entity (CCID)",
      optional: "(optional)",
      pendingSelection: "Pending selection",
      product: "Product",
      reference: "Reference",
      reviewStepButton: "Proceed to Review",
      transactionId: "Transaction ID",
    },
    messages: {
      accountRequired: "Account is required",
      entityRequired: "Entity (CCID) is required",
      amountOverMax: "Amount exceeds available balance",
      amountGreaterThanZero: "Amount must be greater than 0",
      amountRequired: "Amount is required",
      assetRequired: "Asset is required",
    },
    placeholders: {
      selectEntity: "Select an entity",
    },
    buttons: {
      proceedToReview: "Proceed to Review",
    },
    modal: {
      close: "Close",
      advancedSearchTitleStart: "Select",
      advancedSearchTitleEnd: "Account",
      advancedSearchSubtitle:
        "Find the account you want to select either by searching or filtering the columns",
    },
  },
  dashboard: {
    greeting: `Hello `,
    tabs: {
      accounts: "Accounts",
      assets: "Assets",
    },
    cards: {
      totalValuation: "Total Valuation",
      totalCredit: "Total Credit",
      totalEquity: "Total Equity",
      totalMargin: "Total Margin",
      totalsAcrossEntities: "Totals Across Entities",
      fiatVsDigital: "Fiat vs Digital",
      fiat: "Fiat",
      digital: "Digital",
      allocations: "Allocations",
      assetAllocation: "Asset Allocation",
    },
  },
  transactions: {
    tables: {
      title: `Transactions in`,
      id: "Transaction Id",
      lastUpdated: "Time",
      requester: "Requester",
      transactionType: "Type",
      asset: "Asset",
      fromEntity: "From Entity",
      toEntity: "To Entity",
      fromCustomer: "From Customer",
      toCustomer: "To Customer",
      fromProduct: "From Product",
      toProduct: "To Product",
      fromAccount: "From Account",
      toAccount: "To Account",
      amount: "Amount",
      status: "Status",
      reference: "Payment Reference",
      searchPlaceholder: "Search by Transaction ID",
    },
    cards: {
      totalValuation: "Total Valuation",
      fiatVsDigital: "Fiat vs Digital",
      fiat: "Fiat",
      digital: "Digital",
      allocations: "Allocations",
      assetAllocation: "Asset Allocation",
    },
    messages: {
      transactionSuccessTitle: "Transaction pending",
      transactionSuccessMessage:
        "Your transaction is awaiting approval. Transaction ID: { id }",
      copyTransactionId: "Copy Transaction ID",
    },
  },
  accounts: {
    tabs: {
      assets: "Assets",
      transactions: "Transactions",
    },
    tables: {
      account: "Account",
      entity: "Entity",
      customer: "Customer",
      lmaxEntity: "LMAX Entity",
      product: "Product",
      assets: "Assets",
      accountCurrency: "Account Currency",
      valuationTotalCredit: "Credit (USD)",
      valuationTotalEquity: "Equity (USD)",
      valuationTotalMargin: "Margin (USD)",
      valuationTotalCash: "Cash (USD)",
      valuationTotalAvailable: "Available To Withdraw (USD)",
      accountValuationTotalCredit: "Credit",
      accountValuationTotalEquity: "Equity",
      accountValuationTotalMargin: "Margin",
      accountValuationTotalCash: "Cash",
      accountValuationTotalAvailable: "Available To Withdraw",
      actionsButton: "...",
    },
    tooltips: {
      customer:
        "The unique customer ID linked to this account (product-based).",
      account: "The account name and unique account ID.",
      product: "The LMAX product type associated with this account",
      lmaxEntity: "The LMAX legal entity under which this account is held",
      assets:
        "Assets held in this account, such as crypto (e.g. BTC) or fiat (e.g. USD)",
      entity: "The legal entity associated with the Account & Customer.",
      valuationTotalEquity:
        "The total value of all assets in this account, including balances and unrealised trading P&L. Converted to USD (estimated)",
      valuationTotalAvailable:
        "Estimated USD value available for withdrawal or transfer.",
      valuationTotalCredit:
        "The borrowing limit or credit facility assigned to this account converted to USD (estimated)",
      valuationTotalMargin:
        "Required margin to support open positions converted to USD (estimated)",
      valuationTotalCash: "Total cash converted to USD equivalent (estimated)",
      accountValuationTotalEquity:
        "The total value of all assets in this account, including balances and unrealised trading P&L, in account currency)",
      accountValuationTotalAvailable:
        "Estimated value available for withdrawal or transfer, in account currency",
      accountValuationTotalCredit:
        "The borrowing limit or credit facility assigned to this account, in account currency",
      accountValuationTotalMargin:
        "Required margin to support open positions, in account currency",
      accountValuationTotalCash: "Total cash, in account currency",
    },
  },
  account: {
    meta: {
      accountNumber: "Account number",
    },
    cards: {
      total: {
        title: "Available to Withdraw (USD)",
      },
      totals: {
        title: "Totals",
        credit: "Total Credit",
        equity: "Total Equity",
        margin: "Total Margin",
      },
      allocations: {
        title: "Allocations",
      },
    },
  },
  assets: {
    tables: {
      title: "Assets in",
      symbol: "Assets",
      cashAmount: "Cash (Native)",
      cashValuation: "Cash (USD)",
      creditAmount: "Credit (Native)",
      creditValuation: "Credit (USD)",
      allocations: "Allocations",
    },
    tooltips: {
      symbol:
        "Assets held in this account, such as crypto (e.g. BTC) or fiat (e.g. USD)",
      cashAmount:
        "The account's cash shown in the native currency or asset denomination (e.g. BTC, EUR, GBP)",
      cashValuation: "Total cash converted to USD equivalent (estimated).",
      creditAmount:
        "The account's credit shown in the native currency or asset denomination (e.g. BTC, EUR, GBP)",
      creditValuation: "Total credit converted to USD equivalent (estimated).",
      allocations:
        "Total percentage of portfolio allocated to a specific asset",
    },
  },
  transfer: {
    titles: {
      accounts: "Where from and to?",
      amount: "How much?",
      review: "Review & Confirm",
      setup: "Setup transfer",
      successStep: "Submitted",
    },
    summary: {
      accountBalanceBefore: "Account balance before transfer",
      accountBalanceAfter: "Account balance after transfer",
      assetSelected: "Asset selected",
      assetAmount: "Asset transfer amount",
      assetBalanceBefore: "Asset balance before transfer",
      assetBalanceAfter: "Asset balance after transfer",
      viewFullBreakdown: "See account for full breakdown",
    },
    labels: {
      confirmTransfer: "Confirm transfer",
      reviewReference: "Payment reference",
      requester: "Requester",
    },
    tooltips: {
      accountFrom: "Select the account you want to transfer funds from",
      accountTo: "Select the account that will receive the funds",
      asset:
        "Choose the asset type to transfer, such as digital tokens (e.g. BTC) or fiat currencies (e.g. USD).",
      amount:
        "Enter the Native amount of the selected asset you would like to transfer",
      reference:
        "Add a reference or note for internal tracking (e.g. client ID)",
      usdValuations:
        "USD conversions are approximations for guidance only and may vary due to price movements, spreads, and refresh delays. Final USD value is determined at execution.",
    },
    messages: {
      transferFailTitle: "Transfer failed",
      accountHasNoAssets: "From account has no assets",
    },
  },
  transaction: {
    titles: {
      tray: "Transaction details",
      details: "Details",
      moreDetails: "More details",
    },
  },
  configurations: {
    title: "Configuration",
    tabs: {
      transfers: "Transfers",
      b2bTransfers: "B2B Transfers",
    },
    transfers: {
      tables: {
        entity: "Entities (CCID)",
        interAccount: "Inter Account Transfers",
        brokerToBroker: "Broker to Broker Transfers (B2B)",
        crossCustomer: "Cross Customer Transfers",
      },
      tooltips: {
        entity: "The legal entity associated with the account and customer.",
        interAccount:
          "Enables transfers between accounts under the same LMAX legal entity.",
        brokerToBroker:
          "Enables transfers between accounts held under two different LMAX legal entities within the same customer entity.",
        crossCustomer:
          "Enable the movement of funds between distinct customer legal entities (Remittance Transfer).",
      },
    },
    b2b: {
      tables: {
        fromLei: "LMAX Entity 1",
        toLei: "LMAX Entity 2",
        requireApproval: "Approval Required",
        enableDigital: "Enable transfer of Digital Assets",
        enableFiat: "Enable transfer of Fiat Assets",
      },
      tooltips: {
        fromLei:
          "One of the LMAX legal entities, typically defined by jurisdiction.",
        toLei:
          "A second LMAX legal entity, distinct from Entity 1 and typically in a different jurisdiction.",
        requireApproval:
          "Indicates whether transfers from this entity require approval before processing.",
        enableDigital:
          "Allows the entity to transfer supported digital assets (e.g. crypto or tokens) between accounts.",
        enableFiat:
          "Allows the entity to transfer supported fiat currencies (e.g. USD, GBP, EUR) between accounts.",
        defaultState:
          "The default configuration applied to newly added entities. Existing entities are not affected.",
      },
      labels: {
        addConfigButton: "Add configuration",
      },
      form: {
        title: "Add B2B Configuration",
        buttons: {
          addCustomRow: "Add configuration",
        },
        confirm: {
          areYouSureDelete: {
            header:
              "Are you sure you want to delete the following configuration:",
            message:
              "LMAX Entity 1: { lmaxEntity1Name } ({ lmaxEntity1Id })\nLMAX Entity 2: { lmaxEntity2Name } ({ lmaxEntity2Id })",
          },
        },
        messages: {
          LEIS_SHOULD_BE_UNIQUE:
            "LMAX Entity 1 and LMAX Entity 2 are identical; they must be unique",
          errorFetchEntities: "Error fetching B2B transfer configurations",
          createdConfigSuccessTitle: "B2B transfer configuration created",
          createdConfigSuccessMessage:
            "New B2B transfer configuration successfully added",
          createdConfigFailTitle: "B2B transfer configuration failed",
          genericError: "Failed to add B2B transfer configuration",
        },
      },
    },
  },
  docs: {
    pageTitle: "Support & Docs",
    support: {
      title: "Support",
      text: "Get in touch with an LMAX Portal expert",
      email: "info@lmax.com",
    },
    apiDocs: {
      title: "API Docs",
      text: "Guidance to connect to Portal API",
      label: "Go to API docs",
      url: "https://api.risk-hub.lmax.com/docs/platform/index.html",
    },
    faqs: {
      title: "FAQs",
      items: [
        {
          title: "What does this portal do?",
          content: [
            "This is a unified platform that gives you complete visibility across all your LMAX accounts.",
            "It removes the limitations of account-level views by allowing you to perform key actions like transferring assets between accounts directly within the portal.",
            "This makes managing your portfolio faster, simpler, and more efficient.",
          ],
        },
        {
          title: "Can I transfer assets between my accounts?",
          content: [
            "Yes.",
            "You can transfer supported digital assets (e.g. BTC, ETH, USDT) and fiat currencies (e.g. USD, GBP, EUR) between accounts, subject to your legal entity permissions.",
          ],
        },
        {
          title: "Do I still need to contact support for transfers?",
          content: [
            "No.",
            "Transfers can now be initiated directly from the portal.",
            "For complex or restricted transfers, your LMAX account manager or Customer Support team can assist.",
          ],
        },
        {
          title: "How are valuations calculated on the dashboard?",
          content: [
            "Valuations are estimated based on recent market pricing.",
            "Final values may vary depending on execution timing, spreads, and market conditions.",
          ],
        },
        {
          title: "Why can’t I see all my accounts?",
          content: [
            "If an account is missing, it may not be linked to your LMAX SSO profile.",
            "You’ll need to authenticate and add the account to your SSO to view it in the portal.",
          ],
        },
      ],
    },
  },
};
